import { Router } from '@angular/router';
import { Injectable, NgZone } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { StorageManagerService, SettingsService } from '.';
import { Subject } from 'rxjs';
import { Utilities } from './utilities';

const DEFAULT_MINUTES_UNITL_SESSION_TIMEOUT = 480;
const TIMELEFT_IN_MILLISECONDS_BEFORE_SESSION_TIMEOUT = 1000 * 60 * 5;
const CHECK_INTERVAL = 1000; // in ms
const STORE_KEY = 'absoluteAction';


@Injectable()
export class AbsoluteSessionTimeoutService {
    public sessionTimeoutWarning: Subject<number> = new Subject<number>();
    firstTimeWarning: boolean = true;

    constructor(private auth: AuthenticationService, private router: Router, private ngZone: NgZone, private storageManager: StorageManagerService,
        private settingsService: SettingsService) {

        this.check();
        this.initInterval();
    }

    get lastAction() {
        return parseInt(this.storageManager.read(STORE_KEY));
    }

    set lastAction(value) {
        this.storageManager.write(STORE_KEY, value);
    }

    initInterval() {
        this.ngZone.runOutsideAngular(() => {
            setInterval(() => {
                this.check();
            }, CHECK_INTERVAL);
        })
    }

    reset() {        
        if (isNaN(this.lastAction) ) {
            this.lastAction = Date.now();
        }
    }

    check() {
        const now = Date.now();
        let sessionInMinutes: number = DEFAULT_MINUTES_UNITL_SESSION_TIMEOUT * 60 * 1000;

        if (!Utilities.IsUndefined(this.settingsService?.absoluteSessionTimeout?.toString()) && this.settingsService?.absoluteSessionTimeout > 0) {
            sessionInMinutes = this.settingsService.absoluteSessionTimeout * 60 * 1000;
        }


        const timeleft = this.lastAction + sessionInMinutes;
        const diff = timeleft - now;
        const isTimeout = diff < 0;

        this.ngZone.run(() => {
            if (diff < TIMELEFT_IN_MILLISECONDS_BEFORE_SESSION_TIMEOUT && this.firstTimeWarning) {
                this.firstTimeWarning = false;
                this.sessionTimeoutWarning.next(TIMELEFT_IN_MILLISECONDS_BEFORE_SESSION_TIMEOUT);
            }

            if (isTimeout) {
                console.log(`Session has been terminated due to absolute session timeout limit ${sessionInMinutes} minutes.`);
                this.auth.logout();
                this.storageManager.clearAll();
            }
        });
    }
}
